<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M0.5 1.75C0.223858 1.75 0 1.97386 0 2.25V3.75C0 4.02614 0.223858 4.25 0.5 4.25H15.5C15.7761 4.25 16 4.02614 16 3.75V2.25C16 1.97386 15.7761 1.75 15.5 1.75H0.5ZM2 7.25C2 6.97386 2.22386 6.75 2.5 6.75H13.5C13.7761 6.75 14 6.97386 14 7.25V8.75C14 9.02614 13.7761 9.25 13.5 9.25H2.5C2.22386 9.25 2 9.02614 2 8.75V7.25ZM5 12.25C5 11.9739 5.22386 11.75 5.5 11.75H10.5C10.7761 11.75 11 11.9739 11 12.25V13.75C11 14.0261 10.7761 14.25 10.5 14.25H5.5C5.22386 14.25 5 14.0261 5 13.75V12.25Z"
  />
</template>
